import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { AdminStatus, IAdmin } from '@/models/admins.model';
import AdminTableActions from '../AdminTableActions/AdminTableActions';
import StatusTag from '../../components/StatusTag/StatusTag';
import { Tooltip } from '@/ui';
import { getEntityId } from '@/utils';

type TGetAdminsTableColumns = {
  t: TFunction;
  updateAdminStatus: (id: string, status: AdminStatus) => void;
  deleteAdmin: (id: string) => void;
};

export const getAdminsTableColumns = ({
  t,
  updateAdminStatus,
  deleteAdmin,
}: TGetAdminsTableColumns): ColumnsType<IAdmin> => [
  {
    title: t('admins_list_id'),
    dataIndex: 'PK',
    key: 'PK',
    render: (_, record) => <Tooltip title={getEntityId(record.PK)}>{getEntityId(record.PK)?.slice(0, 4)}</Tooltip>,
  },
  {
    title: t('admins_list_name'),
    dataIndex: 'full_name',
    key: 'full_name',
    render: (full_name) => <span>{full_name}</span>,
  },
  {
    title: t('admins_list_role'),
    dataIndex: 'role',
    key: 'role',
    render: (role) => <span>{t(`admin_roles_${role.toLowerCase()}`)}</span>,
  },
  {
    title: t('admins_list_email'),
    dataIndex: 'email',
    key: 'email',
    render: (email) => <span>{email}</span>,
  },
  {
    title: t('admins_list_phone_number'),
    dataIndex: 'phone_number',
    key: 'phone_number',
    render: (phone) => <span>{phone}</span>,
  },
  {
    title: t('admins_list_status'),
    dataIndex: 'status',
    key: 'status',
    render: (status) => <StatusTag status={status} />,
  },
  {
    title: t('admins_list_actions'),
    key: 'actions',
    render: (_, record) => {
      return <AdminTableActions record={record} updateAdminStatus={updateAdminStatus} deleteAdmin={deleteAdmin} />;
    },
  },
];
